import { HttpMethod } from "../../Orchestrator/Types/Types/EndpointTypes";
import { cacheExcludedEndpoints } from "../Config/EndPoints/EndPoints";
import { countries } from "./countries";

export function encodeData(data: any): string | null {
  try {
    if (data === undefined) return null;
    const jsonStr = JSON.stringify(data);
    const utf8Bytes = new TextEncoder().encode(jsonStr); // Encode to UTF-8 bytes
    const base64 = btoa(String.fromCharCode(...Array.from(utf8Bytes))); // Convert bytes to base64
    return base64;

    // return btoa(jsonStr); // InvalidCharacterError: Failed to execute 'btoa' on 'Window': The string to be encoded contains characters outside of the Latin1 range.
  } catch (error) {
    console.error('Failed to encode data:', error);
    return null;
  }
}

export function decodeData<T>(encoded: string): T | null {
  try {
    if (!encoded) return null;
    const binary = atob(encoded); // Decode base64 to binary string
    const bytes = Uint8Array.from(binary, char => char.charCodeAt(0));
    const json = new TextDecoder().decode(bytes); // Decode UTF-8 bytes back to string
    return JSON.parse(json) as T;

    // return JSON.parse(atob(encoded)) as T;
  } catch (error) {
    console.error('Failed to decode data:', error);
    return null;
  }
}

export function extractPathnameFromUrl(path: string): string {
  try {
    // Handle absolute URLs with protocol
    const url = new URL(path, 'http://dummy-base.com');

    if (url.origin === 'http://dummy-base.com' && !path.startsWith('http')) {
      return url.pathname;
    }

    return url.pathname;
  } catch (e) {
    // Fallback for very malformed URLs
    try {
      const parts = path.split('?')[0].split('#')[0];
      const pathStart = parts.indexOf('/');
      return pathStart !== -1 ? parts.slice(pathStart) : '/';
    } catch {
      return '/';
    }
  }
}

export function isCacheExcluded(url: string, method: string): boolean {
  const upperMethod = method.toUpperCase() as HttpMethod;
  const targetPath = extractPathnameFromUrl(url);

  // Suffix match, not equality: the API base path is environment-specific
  // (/retailer-cwp on int & prod, /training/ims/retailer on training), so an
  // exact pathname would only ever match one environment. Entries are therefore
  // written base-agnostic ("/places/all") and matched against the tail.
  let match = cacheExcludedEndpoints.find(item => {
    const itemPath = extractPathnameFromUrl(item.endpoint);
    return (targetPath === itemPath || targetPath.endsWith(itemPath)) && item.methods.includes(upperMethod);
  });

  if (match) return true;

  return false;
}

export function extractMobileCodeAndNumber(input: string): { mobileCode: string | null; phoneNumber: string } {
  let mobileCode = "";
  let phoneNumber = "";

  let phoneNumberStr = input || "";
  if (phoneNumberStr.startsWith("+")) {
    const matchingCountry = countries.find((country) =>
      phoneNumberStr.startsWith(country.countryCallingCode)
    );

    if (matchingCountry) {
      mobileCode = matchingCountry.countryCallingCode;
      phoneNumber = phoneNumberStr.substring(mobileCode.length);
    }
  }

  if (!mobileCode) {
    const uaeCountry = countries.find((country) => country.countryCode === "AE");
    if (uaeCountry) {
      mobileCode = uaeCountry.countryCallingCode;
    }
  }

  return {
    mobileCode: mobileCode || null,
    phoneNumber: phoneNumber
  }
}

export function debounce<T extends (...args: any[]) => void>(
  func: T,
  delay: number
): (...args: Parameters<T>) => void {
  let timer: NodeJS.Timeout;
  return (...args: Parameters<T>) => {
    clearTimeout(timer);
    timer = setTimeout(() => func(...args), delay);
  };
}
